module.exports = __webpack_public_path__ + "static/jay-4ed2b7e2a1966aee9dfd5cbbd3fe9d0b.jpg";